import { Component } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ElementRef } from '@angular/core';
import { swalDesition } from '../config/swalCommon';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/services.index';
import { PushNotificationMiddlewareServicesService } from 'src/app/services/push-notification-middleware.service';
import { User } from 'src/app/interfaces/user';
import { ChangePasswordComponent } from '../../shared/changepassword/changepassword.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  styles: [`
    .bg-fondo { background-color: var(--beige-claro) !important; }
    .division { border-right: solid 1px var(--marron-oscuro); }
    .bloque { padding: 20px 0; text-align: center; vertical-align: middle; line-height: normal; }
    .marco { bottom: 1px; position: relative; box-shadow: 1px 2px 5px 1px #696d76; border-radius: 15px;}
  `]
})
export class NavbarComponent {
  usuario: string;
  role: string;
  socialPhoto: string;
  newNotifications: number;
  lastMessage: string;
  showAlert: boolean;
  menu: boolean;
  userData: User;
  showBarUserNotification: Boolean = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private notifiService: NotificationService,
    private notifiMiddleware: PushNotificationMiddlewareServicesService,
    public element: ElementRef,
    private modalService: NgbModal,

  ) {
    this.role = this.userService.user.role;
    this.socialPhoto = sessionStorage.getItem('socialPhoto') || 'assets/img/avatar/user.svg';
    this.usuario = `${this.userService.user?.name} ${this.userService.user?.lastName}`;
    if (!this.notifiMiddleware.pushNotificationStatus.isSubscribed) {
      this.notifiMiddleware.subscribeUser(this.userService.user.id);
    }
    this.menu = false;
    
    // Intentar conectar SignalR con manejo de errores
    this.notifiService.startConnection(this.userService.user.id)
      .then(() => console.log('✅ SignalR: Conexión establecida'))
      .catch(err => console.error('❌ SignalR: Error de conexión (usando fallback)', err));
    
    this.userData = this.userService.user;

    this.notifiService.notificationsModalStatus.subscribe(status => {
      this.showBarUserNotification = status;
    });
  }

  logout = () => Swal.fire(swalDesition('¿Está seguro que desea salir?')).then((result) => {
    if (result.value) {
      this.notifiMiddleware.unsubscribeUser();
      this.notifiService.socket?.stop();
      this.userService.revokeToken().subscribe(() => this.finishLogOut(), () => this.finishLogOut());
    }
  })

  finishLogOut() {
    sessionStorage.removeItem('socialPhoto');
    sessionStorage.removeItem('firstAccess');
    sessionStorage.removeItem('adjudicadoDetailsTMP');
    sessionStorage.removeItem('documentsListCorrection');
    sessionStorage.removeItem('documentsVersion');
    sessionStorage.removeItem('activateCorrectionDoc');
    this.userService.logout();
    this.router.navigate(['/login']);
  }

  hasRole(roles: string[]) {

    return roles.includes(this.role);
  }

  alert(title: string) {
    this.lastMessage = title;
    this.showAlert = true;
    setTimeout(() => this.showAlert = false, 6000);
  }

  toggle = () => this.menu = (this.menu) ? false : true;


  notificaciones = () => this.userData.role == 'Super administrador' ? this.router.navigate(['/notificaciones/admin']) : this.router.navigate(['/notificaciones/user']);

  showUserNotification = () => {(!this.showBarUserNotification) ? this.showBarUserNotification = true : this.showBarUserNotification = false;}

  changePassword =()=>  {
    const modal = this.modalService.open(ChangePasswordComponent, { size: 'lg', centered: true, backdrop: 'static' })};


}
